export const mirrorWidgetsForTimeComparisonReport = (
  widgets,
  compareStartDate,
  compareEndDate,
  setMirrored
) =>
  widgets.reduce((all, each) => {
    // push compare first since they live on left side
    const compare = { ...each };
    compare.startDate = compareStartDate;
    compare.endDate = compareEndDate;
    compare.editable = false;
    compare.mirrored = setMirrored;
    all.push(compare);

    all.push(each);
    return all;
  }, []);

export const isSocialMediaOrNewsMention = (channelType) =>
  "facebook,instagram,tiktok,twitter,news".includes(channelType);
